<template>
  <div class="payment-panel">
    <panel-payment-selection
      v-if="registerPaymentPanel === '' || registerPaymentPanel === 'default'"
      style="position: relative; right: 0"
      :data="invoice"
      :selectedPrinter="selectedPrinter"
      :keyboardShortcutsEnabled="keyboardShortcutsEnabled"
      :showShortcutBadges="showShortcutBadges"
      :showBadgesTemporarily="showBadgesTemporarily"
      :quantityBarEnabled="quantityBarEnabled"
      :selectedQuantity="selectedQuantity"
      @selectTable="onSelectTable"
      @recalculate="onRecalculate"
      @clearSelection="onClearSelection"
      @openCloseBalanceDialog="onOpenCloseBalanceDialog"
      @openSearchItemsDialog="onOpenSearchItemsDialog"
      @openReceiptsDialog="onOpenReceiptsDialog"
      @sendNotes="onSendNotes"
      @resetNotes="onResetNodes"
      @createNewTable="onCreateNewTable"
      @addWriteInProduct="onAddWriteInProduct"
      @quantity-changed="onQuantityChanged">
    </panel-payment-selection>

    <panel-payment-selection-simple
      v-if="registerPaymentPanel === 'simple'"
      style="position: relative; right: 0"
      :data="invoice"
      :selectedPrinter="selectedPrinter"
      @selectTable="onSelectTable"
      @recalculate="onRecalculate"
      @openCloseBalanceDialog="onOpenCloseBalanceDialog"
      @openSearchItemsDialog="onOpenSearchItemsDialog"
      @openReceiptsDialog="onOpenReceiptsDialog"
      @sendNotes="onSendNotes"
      @resetNotes="onResetNodes">
    </panel-payment-selection-simple>
  </div>
</template>

<script>
import PanelPaymentSelection from '@/modules/cash-register/components/PanelPaymentSelection'
import PanelPaymentSelectionSimple from '@/modules/cash-register/components/PanelPaymentSelectionSimple'
import { df } from '@/plugins/firebase'
import state from '@/state'
import EventBus from '@/plugins/event-bus'

export default {
  name: 'PaymentPanel',

  components: {
    PanelPaymentSelection,
    PanelPaymentSelectionSimple
  },

  props: {
    invoice: {
      type: Object,
      required: true
    },
    selectedTable: {
      type: Object,
      default: () => ({})
    },
    cashReg: {
      type: Object,
      required: true
    },
    selectedPrinter: {
      type: Object,
      default: () => ({})
    },
    keyboardShortcutsEnabled: {
      type: Boolean,
      default: false
    },
    showShortcutBadges: {
      type: Boolean,
      default: false
    },
    quantityBarEnabled: {
      type: Boolean,
      default: false
    },
    selectedQuantity: {
      type: Number,
      default: 1
    }
  },

  data () {
    return {
      registerPaymentPanel: '',
      showBadgesTemporarily: false // Local state for temporary badge display
    }
  },

  created () {
    this.setRegisterPaymentPanel()
  },

  mounted () {
    // Listen for payment panel changes
    EventBus.$off('change-register-payment-panel')
    EventBus.$on('change-register-payment-panel', (newPanel) => {
      this.registerPaymentPanel = newPanel || state.getRegisterPaymentPanel()
    })

    // Listen for Space key badge display events from ProductGrid
    EventBus.$off('show-badges-temporarily')
    EventBus.$on('show-badges-temporarily', (show) => {
      this.showBadgesTemporarily = show
    })
  },

  beforeDestroy () {
    // Remove EventBus listeners
    EventBus.$off('change-register-payment-panel')
    EventBus.$off('show-badges-temporarily')
  },

  methods: {
    async setRegisterPaymentPanel () {
      const register = await df.doc(`cash_registers/${this.cashReg.id}`).get()
      if (register && register.data()) {
        const doc = register.data()
        if (doc && doc.register_payment_panel) {
          state.setRegisterPaymentPanel(doc.register_payment_panel)
        } else {
          state.setRegisterPaymentPanel('default')
        }
      } else {
        state.setRegisterPaymentPanel('default')
      }
      this.registerPaymentPanel = state.getRegisterPaymentPanel()
    },

    // Event forwarding methods
    onSelectTable (table) {
      this.$emit('select-table', table)
    },

    onRecalculate () {
      this.$emit('recalculate')
    },

    onClearSelection () {
      this.$emit('clear-selection')
    },

    onOpenCloseBalanceDialog () {
      this.$emit('open-close-balance-dialog')
    },

    onOpenSearchItemsDialog () {
      this.$emit('open-search-items-dialog')
    },

    onOpenReceiptsDialog () {
      this.$emit('open-receipts-dialog')
    },

    onSendNotes (_, order) {
      this.$emit('send-notes', _, order)
    },

    onResetNodes () {
      this.$emit('reset-notes')
    },

    onCreateNewTable (sourceTable, destinationTable) {
      this.$emit('create-new-table', sourceTable, destinationTable)
    },

    onAddWriteInProduct (item) {
      this.$emit('add-write-in-product', item)
    },

    onQuantityChanged (quantity) {
      this.$emit('quantity-changed', quantity)
    }
  }
}
</script>

<style scoped>
.payment-panel {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
